import './PaymentSuccess.css';
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useSetRecoilState } from 'recoil';
import { navigationBarState } from '../../states/NavigationBar';
import toast from 'react-hot-toast';
import Lottie from "lottie-react";
import completeLottieData from '../Test/Complete/complete.json';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

function PaymentSuccess() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const setNavigationBarState = useSetRecoilState(navigationBarState);

    const [status, setStatus] = useState('processing'); // processing, success, error
    const [errorMessage, setErrorMessage] = useState('');

    useEffect(() => {
        setNavigationBarState(null);
        confirmPayment();
    }, []);

    const confirmPayment = async () => {
        const paymentKey = searchParams.get('paymentKey');
        const orderId = searchParams.get('orderId');
        const amount = searchParams.get('amount');

        if (!paymentKey || !orderId || !amount) {
            setStatus('error');
            setErrorMessage('결제 정보가 올바르지 않습니다.');
            return;
        }

        // Retrieve pending application data from sessionStorage
        const pendingApplicationStr = sessionStorage.getItem('pendingTestApplication');
        if (!pendingApplicationStr) {
            setStatus('error');
            setErrorMessage('신청 정보를 찾을 수 없습니다.');
            return;
        }

        const pendingApplication = JSON.parse(pendingApplicationStr);

        // Verify order ID matches
        if (pendingApplication.order_id !== orderId) {
            setStatus('error');
            setErrorMessage('주문 정보가 일치하지 않습니다.');
            return;
        }

        try {
            // Call backend to confirm payment and complete test application
            const response = await axios.post('/tests/store/confirm-payment/', {
                payment_key: paymentKey,
                order_id: orderId,
                amount: parseInt(amount, 10),
                test_id: pendingApplication.test_id,
                english_name: pendingApplication.english_name,
                phone_number: pendingApplication.phone_number
            });

            if (response.data.success) {
                setStatus('success');
                toast.success('시험 신청이 완료되었습니다!');
                // Clear pending application data
                sessionStorage.removeItem('pendingTestApplication');
            } else {
                setStatus('error');
                setErrorMessage(response.data.message || '결제 확인에 실패했습니다.');
            }
        } catch (error) {
            setStatus('error');
            setErrorMessage(error.response?.data?.message || '결제 처리 중 오류가 발생했습니다.');
        }
    };

    const handleGoToTests = () => {
        navigate('/tests', { replace: true });
    };

    const handleGoBack = () => {
        navigate(-2); // Go back to application form
    };

    return (
        <div className="payment-result-container">
            {status === 'processing' && (
                <>
                    <div className="payment-result-information">
                        <div className="payment-result-spinner"></div>
                        <div className="payment-result-title">결제 처리 중...</div>
                        <div className="payment-result-description">잠시만 기다려주세요.</div>
                    </div>
                </>
            )}

            {status === 'success' && (
                <>
                    <div className="payment-result-information">
                        <Lottie className="payment-result-logo" animationData={completeLottieData} />
                        <div className="payment-result-title">신청완료</div>
                        <div className="payment-result-description">
                            시험 신청이 완료되었습니다.<br />
                            나의 시험 목록에서 확인하세요.
                        </div>
                    </div>
                    <div
                        className="payment-result-confirm-button ripple-key-color"
                        onClick={handleGoToTests}
                    >
                        확인
                    </div>
                </>
            )}

            {status === 'error' && (
                <>
                    <div className="payment-result-information">
                        <div className="payment-result-error-icon">
                            <ErrorOutlineIcon style={{ fontSize: 98, color: '#DC2626' }} />
                        </div>
                        <div className="payment-result-title">결제 실패</div>
                        <div className="payment-result-description">{errorMessage}</div>
                    </div>
                    <div
                        className="payment-result-confirm-button ripple-key-color"
                        onClick={handleGoBack}
                    >
                        돌아가기
                    </div>
                </>
            )}
        </div>
    );
}

export default PaymentSuccess;
